export default class MoveMessage {
    constructor(props) {
        this.move(props.data);
    }

    move(data) {
        data.forEach((el) => {
            let classTo = el.hasOwnProperty('classTo') && el.classTo && el.classTo.length > 1 ? el.classTo : null;

            if(el.hasOwnProperty('type') && el.type === 'prepend') {
                $(el.to).prepend($(el.selector));
            }else {
                $(el.to).append($(el.selector));
            }

            this.toggleError($(el.selector), classTo);
        });
    }

    toggleError($selector, classTo = null) {
        let $items = $selector.find('li');

        $items.each((index, el) => {
            let id = $(el).attr('data-id');
            let $field = $(`#${id}`);

            if($field.length) {
                if(classTo) {
                    if($field.closest(classTo).length) {
                        $field.closest(classTo).addClass('error');
                    }else {
                        console.warn(`The closest ${classTo} selector was not found. Class was add to parent selector.`);
                        $field.parent().addClass('error');
                    }
                }else {
                    $field.parent().addClass('error');
                }
            }
        });
    }
}